module.exports = __webpack_public_path__ + "img/card10.516f4870.jpg";